import { User } from 'CommonScripts/user';
import { RequestService } from './request.service';

export class CommercialCMSService {
    public static async postCommercialCTA(data: any) {
        return await RequestService.post(`${process.env.COMMERCIAL_CMS_URL}/process-cta`, { 
            ...data, 
            Source: 'APV',
            AppInstanceGUID: User.getUserId(), 
        });
    }
}